<template>
    <div class="templete_box">
        <div class="templete">
            <div class="search_box search_box_f clearfix">
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" value-format="timestamp" format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始日期"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_time" value-format="timestamp" format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
                </div>
                <el-select class="search_select search_inputBox" v-model="params.warehouse_id" multiple collapse-tags placeholder="盘点仓库">
                    <el-option v-for="list in warehouseList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.creator_id" multiple collapse-tags placeholder="制单人">
                    <el-option v-for="list in creatorList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.checker_id" multiple collapse-tags placeholder="盘点人">
                    <el-option v-for="list in checkerList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_select search_inputBox" v-model="params.check_sn" placeholder="盘点单号" size="mini"></el-input>
                <el-input class="search_select search_inputBox" v-model="params.remark" placeholder="备注" size="mini"></el-input>
                <!-- <el-select class="search_select search_inputBox" v-model="params.brand_id" multiple collapse-tags placeholder="品牌" @visible-change="getSelectsaleCostSeeList('brand_id')">
                    <el-option v-for="list in selectMapS.brand_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.breed_id" multiple collapse-tags placeholder="品名" @visible-change="getSelectsaleCostSeeList('breed_id')">
                    <el-option v-for="list in selectMapS.breed_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.grade_id" multiple collapse-tags placeholder="等级" @visible-change="getSelectsaleCostSeeList('grade_id')">
                    <el-option v-for="list in selectMapS.grade_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.original_thickness" multiple collapse-tags placeholder="厚度" @visible-change="getSelectsaleCostSeeList('original_thickness')">
                    <el-option v-for="list in selectMapS.original_thickness" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_select search_inputBox" v-model="params.contract_no" placeholder="合同号" size="mini"></el-input>
                <el-input class="search_select search_inputBox" v-model="params.container_no" placeholder="货柜号" size="mini"></el-input> -->
                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="resetSearch">重置</div>
                    <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                </div>
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                    <!-- <span class="excel_btn" @click="excelExport"><i class="excel-icon"></i>excel导出</span> -->
                </div>
            </div>
            <div class="tableBox">
                <tabletem :isSetCol="true" scene="inventory.check.logs" :isLoading="tableLoading" @rowClick="rowClick" @dialogViewClick="dialogViewClick" :tablecol="tableCol" :tabledata="list"></tabletem>
            </div>
            <div class="totalCal no_print">
                <div class="totalName">合计：</div>
                <div class="totalNumber">盘点盈亏: <span :style="totalObj.number_diff>0?'color: #5bcca1':'color: red'"> {{totalObj.number_diff}}</span></div>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="inventory.check.logs" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <!-- 详情 START -->
        <el-dialog v-dialog-drag :visible.sync="costLogDetailDialog" class="eldialog"
                width="490px" :modal="false" :title="'详情'" custom-class="full_dialog">
            <div class="tableBox" style="max-height: 200px">
            <tabletem :isShowIndex="true" :is-hide-checkout="false" :isHideColumn="false" :is-align-center="true"  :tablecol="costLogDetailTableCol" :tabledata="costLogDetailList">
            </tabletem>
            </div>
            <div class="costLogBottomBtn" style="padding: 30px 0 0;">
                <el-button type="primary" @click="costLogDetailDialog=false">我知道了</el-button>
            </div>
        </el-dialog>
        <!-- 详情 END -->
        <el-dialog v-dialog-drag title="盘点笔记" :visible.sync="noteVisible" width="460px !important" class="eldialog eldialogA" :model="false">
            <el-form  ref="sure_form">
                <textarea class="edit_input edit_textarea" placeholder="输入盘点笔记" style="width:65%;"  v-model="note_remark"></textarea>
                <div class="dialogBtnList clearfix">
                    <el-button  class="publicBtn dialogBtn"  @click="noteChangeSure">确定</el-button>
                    <el-button class="dialogBtn funcPublicBtn" @click="outnoteVisible()">取消</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>
<style scoped lang="scss">
</style>
<script>
    import pagination from '../../components/pagination.vue'
    import tabletem from '../../components/table.vue'
    export default {
        components:{
            pagination,
            tabletem
        },
        data(){
            return{
                tableLoading:false,
                module:localStorage.dw_erp_power_code,
                params:{
                    start_time:"",
                    end_time:"",
                    check_sn:"",
                    remark:"",
                    warehouse_id:"",
                    creator_id:"",
                    checker_id:"",
                    per_page: 50,
                    page:1
                },
                start_time:"",
                end_time:"",
                last_page: 1,
                current_page: 1,
                total: 0,
                updataType:2,//2新增，3修改
                list : [],
                proList:[],
                cityList:[],
                searchCityList:[],
                selectMap:{
                    user:[],
                },
                selectMapS:{
                    supplier_id:[],
                    breed_id:[],
                    brand_id:[],
                    grade_id:[],
                    original_thickness:[]
                },
                // dialog
                dialogVisible : false,
                filterDialogVisible:false,
                filter:"",
                fields:"",
                totalObj:{},
                tableCol:[	
                    {colName:"盘点日期",colKey:"check_date",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"盘点单号",colKey:"check_sn",colWidth:90,isSetWidth:true,isShow:true,isCanClick:true},
                    {colName:"盘点仓库",colKey:"warehouse",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"盘点件数(件)",colKey:"wait_number",colWidth:90,htmlNodeFunc(row) {
                            let color = row['check_number'] > row['wait_number'] ? 'green' : row['check_number'] == row['wait_number']?'':'red';
                            return `<span style="color:${color}">${row['check_number']}</span>/<span>${row['wait_number']}</span>`;
                        },isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"缺失库存",colKey:"check_id",colWidth:90,isSetWidth:true,isShow:true,isCanClick:true,isColor:true,isHideShowClickImg:true,isHideCanClickColor:true}, 
                    {colName:"盘点盈亏",colKey:"number_diff",colWidth:90,htmlNodeFunc(row) {
                            let color = row['number_diff'] > 0 ? 'green' : row['check_number'] == 0?'':'red';
                            return `<span style="color:${color}">${row['number_diff']}</span>`;
                        },isSetWidth:true,isCanClick:false,isShow:true}, 
                    {colName:"制单人",colKey:"creator_name",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"盘点人",colKey:"checker_name",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"盘点笔记",colKey:"process_status",colWidth:90,isSetWidth:true,isCanClick:false,isShow:false,isColor:false,isRecordView:true},
                    {colName:"备注",colKey:"remark",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                ],
                warehouseList:[],
                creatorList:[],
                checkerList:[],
                costLogDetailDialog:false,
                costLogDetailList:[],
                costLogDetailTableCol:[
                    {colName:"捆包号",colKey:"bale_no",},
                    {colName:"品名",colKey:"breed"},
                    {colName:"品牌",colKey:"brand"},
                    {colName:"等级",colKey:"grade"},
                ],
                noteVisible:false,
                note_remark:'',
                note_remark_id:''
            }
        },
        created(){
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.postFunc("/erp/inventory.check.warehouse.options",{},res=>{
                this.warehouseList=res.data.data;
            },error=>{
                this.tip(error.data.message,"warning")
            });
            this.postFunc("/erp/inventory.check.creator.options",{},res=>{
                this.creatorList=res.data.data;
            },error=>{
                this.tip(error.data.message,"warning")
            });
            this.postFunc("/erp/inventory.check.checker.options",{},res=>{
                this.checkerList=res.data.data;
            },error=>{
                this.tip(error.data.message,"warning")
            });
            this.getList();
        },
        methods:{
            // excelExport(){
            //     this.$exportExecl("/erp/inventory.cost.export","成本查看",this.params)
            // },
            filterConfirm(){
                this.getList()
            },
            getSelectsaleCostSeeList(target){
                this.$getSelectsaleCostSeeList(target,this.params).then(res=>{
                    this.selectMapS[res.data.data.target]=res.data.data.result;
                })
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.start_time = this.formatTimeZero(this.start_time)
                this.params.end_time = this.formatTimeZero(this.end_time)
                this.tableLoading = true;
                this.$postColumnList("/erp/inventory.check.logs",this.params,res=>{
                    this.pl(res)
                    this.last_page=parseInt(res.data.data.list.last_page);
                    // this.params.page=parseInt(res.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.list.total);
                    this.totalObj = res.data.data.total;
                    this.list=res.data.data.list.data;
                    this.list.forEach((item,index)=>{
                        if(item.process_status==1){
                            item.isDialogViewrecorda=true;
                        }else{
                             item.isDialogViewrecordb=true;
                        }
                        if(item.check_date!=0){
                            this.list[index].check_date = this.formatTime(item.check_date+"000")
                        }else{
                            this.list[index].check_date = "";
                        }
                        if(item.check_id){
                            item.check_id = '查看详情'
                        }
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            rowClick(obj){
                if(obj.name=='check_sn'){
                    sessionStorage.setItem("Record_ID",obj.id);
                    // this.$root.$children[0].$children[0].showTab({
                    //     label: "盘点记录",
                    //     name: "盘点记录",
                    //     content: "warehouseRecord",
                    // });
                    this.$root.$children[0].$children[0].addTab({
                        name: '盘点详情'+obj.id,
                        label: '盘点详情',
                        content: 'warehouseRecord'
                    });
                }else if(obj.name=='check_id'){
                    this.postFunc('/erp/inventory.check.logs.miss',{check_id:obj.id},res=>{
                        this.costLogDetailDialog = true;
                        let resD = res.data.data;
                        this.costLogDetailList = Array.isArray(resD) ? resD : [];
                    })
                }else if(obj.name=='check_id'){}
            },
            dialogViewClick(row){
                this.note_remark=row.row.process_remark;
                this.note_remark_id = row.row.id;
                this.noteVisible = true;
            },
            noteChangeSure(){
                this.postFunc('/erp/inventory.check.log.remark',{id:this.note_remark_id,remark:this.note_remark},res=>{
                    this.noteVisible = false;
                    this.getList();
                })
            },
            outnoteVisible(){
                this.noteVisible = false;
            },
            resetSearch(){
                this.params = this.params = {
                    start_time:"",
                    end_time:"",
                    container_no:"",
                    contract_no:"",
                    brand_id:[],
                    breed_id:[],
                    grade_id:[],
                    original_thickness:[],
                    per_page: 50,
                    page:1
                }
                this.start_time = "";
                this.end_time = "";
                this.getList()
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
        },
        watch:{
            dialogVisible:function(val){
                if(!val){
                    this.form_params = this.resetJson(this.form_params)
                }
            },
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            }
        }
    }
</script>
